import type { InjectionKey } from 'vue'

export type RuleResponse = true | string

export type RuleArray = Array<() => RuleResponse>

export const BASE_RULES_KEY = Symbol() as InjectionKey<{
    // Methods
    required(message?: string): (value?: string | number | boolean) => RuleResponse
    minLength(minVal: number, message: string): (value?: string) => RuleResponse
    email(value?: string): RuleResponse
    password(value?: string): RuleResponse
    passwordOld(value?: string): RuleResponse
    between(minVal: number, maxVal: number, message: string): (value?: string) => RuleResponse
    noNumbers(value?: string): RuleResponse
    noSpecialCharacters(value?: string): RuleResponse

    // Consts
    EMAIL: RuleArray
    EXISTING_PASSWORD: RuleArray
    NEW_PASSWORD: RuleArray
}>
